import { Box } from 'rebass';
import styled from 'styled-components';
import { display } from 'styled-system';

const ResponsiveBox = styled(Box)`
  ${display};
`;

export default ResponsiveBox;
